import AutoStockSlipViewModal from '@/view/components/stock-slips/AutoStockSlipViewModal.vue'
import {
  openImeiHistoryDocument,
  openStockHistoryDocument,
} from '@/utils/imeiHistoryDocument'

export default {
  components: {
    AutoStockSlipViewModal,
  },
  data() {
    return {
      showAutoStockSlipViewModal: false,
      autoStockSlipViewSlipId: null,
      autoStockSlipViewSlipType: null,
      autoStockSlipViewDirection: 'export',
    }
  },
  methods: {
    openAutoStockSlipViewModal(payload = {}) {
      this.autoStockSlipViewSlipId = payload.slipId
      this.autoStockSlipViewSlipType = payload.slipType
      this.autoStockSlipViewDirection = payload.direction || 'export'
      this.showAutoStockSlipViewModal = true
    },
    openImeiHistoryDocumentLink(item) {
      openImeiHistoryDocument(this.$router, item, {
        onOpenModal: (payload) => this.openAutoStockSlipViewModal(payload),
      })
    },
    openStockHistoryDocumentLink(item) {
      openStockHistoryDocument(this.$router, item, {
        onOpenModal: (payload) => this.openAutoStockSlipViewModal(payload),
      })
    },
  },
}
